import React from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const CollapsibleSection = ({ title, icon: Icon, isOpen, onToggle, children }) => (
  <>
    <button
      type="button"
      onClick={onToggle}
      className="w-full flex items-center justify-between p-4 bg-[#FAF9F7] rounded-lg hover:bg-[#F5F3F0] transition-colors mb-4"
      data-testid={`section-toggle-${title.toLowerCase().replace(/[^a-z]+/g, '-')}`}
    >
      <div className="flex items-center gap-3">
        <Icon className="text-[#DE92A9]" size={20} />
        <span
          className="text-lg font-medium text-[#2C2C2C]"
          style={{ fontFamily: '"Playfair Display", serif' }}
        >
          {title}
        </span>
      </div>
      {isOpen ? <ChevronUp className="text-[#DE92A9]" /> : <ChevronDown className="text-[#757B7F]" />}
    </button>
    {isOpen && (
      <div className="space-y-4 pl-4 border-l-2 border-[#DE92A9]/20 mb-8">{children}</div>
    )}
  </>
);

export default CollapsibleSection;
